import { gql } from '@apollo/client'

export const ADD_NEW_BRANCH = gql`
  mutation ADD_NEW_BRANCH(
    $name: String!
    $users: [ID!]!
    $phones: [String!]!
    $diagnosticFee: Float
    $address: String!
    $location: String
    $defaultPriceList: ID
    $availablePriceLists: [ID!]!
    $specialities: [ChartTypes]
    $appointmentTypes: [AppointmentType]
  ) {
    addNewBranch(
      name: $name
      users: $users
      phones: $phones
      diagnosticFee: $diagnosticFee
      address: $address
      location: $location
      defaultPriceList: $defaultPriceList
      availablePriceLists: $availablePriceLists
      specialities: $specialities
      appointmentTypes: $appointmentTypes
    ) {
      id
      name
      disabled
      diagnosticFee
      address
      location
      phones
      specialities
      appointmentTypes
      users {
        id
        name
        group {
          id
          name
          color
        }
      }
      defaultPriceList {
        id
        name
      }
      availablePriceLists {
        id
        name
      }
      updatedAt
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_BRANCH = gql`
  mutation EDIT_BRANCH(
    $name: String!
    $users: [ID!]!
    $branch: ID!
    $phones: [String!]!
    $diagnosticFee: Float
    $address: String!
    $location: String
    $defaultPriceList: ID
    $availablePriceLists: [ID!]!
    $specialities: [ChartTypes]
    $appointmentTypes: [AppointmentType]
  ) {
    editBranch(
      branch: $branch
      name: $name
      users: $users
      phones: $phones
      diagnosticFee: $diagnosticFee
      address: $address
      location: $location
      defaultPriceList: $defaultPriceList
      availablePriceLists: $availablePriceLists
      specialities: $specialities
      appointmentTypes: $appointmentTypes
    ) {
      id
      name
      disabled
      diagnosticFee
      address
      location
      specialities
      appointmentTypes
      phones
      users {
        id
        name
        group {
          id
          name
          color
        }
      }
      defaultPriceList {
        id
        name
      }
      availablePriceLists {
        id
        name
      }
      updatedAt
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export const EDIT_BRANCH_USERS = gql`
  mutation EDIT_BRANCH_USERS(
    $branch: ID!
    $invoiceUsers: [ID!]!
    $quotationUsers: [ID!]!
    $formUsers: [ID!]!
    $prescriptionUsers: [ID!]!
    $labOrderUsers: [ID!]!
    $appointmentUsers: [ID!]!
  ) {
    editBranchUsers(
      branch: $branch
      invoiceUsers: $invoiceUsers
      quotationUsers: $quotationUsers
      formUsers: $formUsers
      prescriptionUsers: $prescriptionUsers
      labOrderUsers: $labOrderUsers
      appointmentUsers: $appointmentUsers
    ) {
      id
      invoiceUsers {
        id
        name
      }
      quotationUsers {
        id
        name
      }
      formUsers {
        id
        name
      }
      prescriptionUsers {
        id
        name
      }
      labOrderUsers {
        id
        name
      }
      appointmentUsers {
        id
        name
      }
    }
  }
`

export const EDIT_BRANCH_CALENDAR = gql`
  mutation EDIT_BRANCH_CALENDAR(
    $branch: ID!
    $opens: [DateTime!]!
    $closes: [DateTime!]!
    $viewClosedTimes: Boolean!
    $openDays: [Int!]!
    $rooms: String!
    $firstDay: Int
    $breaks: String
    $holidays: [Int]
  ) {
    editBranchCalendar(
      branch: $branch
      opens: $opens
      closes: $closes
      viewClosedTimes: $viewClosedTimes
      openDays: $openDays
      rooms: $rooms
      firstDay: $firstDay
      breaks: $breaks
      holidays: $holidays
    ) {
      id
      opens
      closes
      openDays
      viewClosedTimes
      rooms
      firstDay
      breaks
      holidays
    }
  }
`

export const EDIT_BRANCH_TREASURY = gql`
  mutation EDIT_BRANCH_TREASURY($branch: ID!, $branchTreasuries: [BranchTreasuryInput]) {
    editBranchTreasury(branch: $branch, branchTreasuries: $branchTreasuries) {
      id
      branchTreasuries {
        id
        type
        defaultTreasury {
          id
          name
        }
        availableTreasuries {
          id
          name
        }
        allowPending
      }
    }
  }
`

export const DISABLE_BRANCH = gql`
  mutation DISABLE_BRANCH($branch: ID!, $disabled: Boolean!) {
    disableBranch(branch: $branch, disabled: $disabled) {
      id
      disabled
    }
  }
`
export const DISABLE_PATIENT = gql`
  mutation DISABLE_PATIENT($patient: ID!, $disabled: Boolean!) {
    disablePatient(patient: $patient, disabled: $disabled) {
      id
      type
      disabled
    }
  }
`
export const EDIT_FIELDS = gql`
  mutation EDIT_FIELDS($fields: [FieldCreateWithoutCompanyInput!]!) {
    editCompanyFields(fields: $fields) {
      id
      name
      type
      required
      parent
    }
  }
`
export const DELETE_FIELD = gql`
  mutation DELETE_FIELD($field: ID!) {
    deleteCompanyField(field: $field) {
      id
    }
  }
`

export const UPDATE_COMPANY_MUTATION = gql`
  mutation UPDATE_COMPANY_MUTATION(
    $companyName: String!
    $companyLoginName: String!
    $code: String
    $tax: Float
    $currency: String
    $requiredToPay: Float
    $askBeforeSms: Boolean
    $askBeforeOperation: Boolean!
    $allowDelete: Boolean!
    $allowPrescriptionQR: Boolean!
    $allowFormQR: Boolean!
    $allowInvoiceQR: Boolean!
    $allowChartQR: Boolean!
    $allowLabOrderQR: Boolean!
    $allowEncounterQR: Boolean!
    $allowMedicalQR: Boolean!
    $allowExpenseQR: Boolean!
    $darkCalendar: Boolean!
    $alertBeforeInventory: Int
    $alertBeforeMaster: Int
    $alertBeforeOperations: Int
    $initialAppointment: AppointmentStatus
    $requiredPatientFields: [String]
    $requiredLeadFields: [String]
    $requiredPendingPatientFields: [String]
    $requiredQrPatientFields: [String]
    $visiblePatientFields: [String]
    $selectedOperations: [OperationStatusType]
    $hideQueue: Boolean
    $showLogoInQr: Boolean!
    $confirmInventory: Boolean!
    $defaultLanguage: String
    $cancellationReasons: [String]
    $extraSettings: String
  ) {
    updateCompanyDetails(
      companyName: $companyName
      companyLoginName: $companyLoginName
      code: $code
      tax: $tax
      currency: $currency
      requiredToPay: $requiredToPay
      askBeforeSms: $askBeforeSms
      askBeforeOperation: $askBeforeOperation
      allowDelete: $allowDelete
      allowPrescriptionQR: $allowPrescriptionQR
      allowFormQR: $allowFormQR
      allowInvoiceQR: $allowInvoiceQR
      allowChartQR: $allowChartQR
      allowLabOrderQR: $allowLabOrderQR
      allowEncounterQR: $allowEncounterQR
      allowMedicalQR: $allowMedicalQR
      allowExpenseQR: $allowExpenseQR
      darkCalendar: $darkCalendar
      confirmInventory: $confirmInventory
      alertBeforeInventory: $alertBeforeInventory
      alertBeforeMaster: $alertBeforeMaster
      alertBeforeOperations: $alertBeforeOperations
      initialAppointment: $initialAppointment
      requiredPatientFields: $requiredPatientFields
      requiredLeadFields: $requiredLeadFields
      requiredPendingPatientFields: $requiredPendingPatientFields
      requiredQrPatientFields: $requiredQrPatientFields
      visiblePatientFields: $visiblePatientFields
      selectedOperations: $selectedOperations
      hideQueue: $hideQueue
      defaultLanguage: $defaultLanguage
      showLogoInQr: $showLogoInQr
      cancellationReasons: $cancellationReasons
      extraSettings: $extraSettings
    ) {
      id
      companyName
      companyLoginName
      country
      currency
      code
      timeZone
      tax
      requiredToPay
      askBeforeSms
      askBeforeOperation
      allowDelete
      allowPrescriptionQR
      allowFormQR
      allowInvoiceQR
      allowChartQR
      allowLabOrderQR
      allowEncounterQR
      allowMedicalQR
      allowExpenseQR
      confirmInventory
      darkCalendar
      alertBeforeInventory
      alertBeforeMaster
      alertBeforeOperations
      initialAppointment
      requiredPatientFields
      requiredLeadFields
      requiredPendingPatientFields
      requiredQrPatientFields
      visiblePatientFields
      selectedOperations
      hideQueue
      defaultLanguage
      showLogoInQr
      cancellationReasons
      extraSettings
    }
  }
`
export const ADD_NEW_GROUP = gql`
  mutation ADD_NEW_GROUP(
    $name: String!
    $description: String
    $color: String!
    $permissions: [Permission!]!
    $allowedIps: [String!]
  ) {
    addNewGroup(name: $name, color: $color, description: $description, permissions: $permissions, allowedIps: $allowedIps) {
      id
      name
      color
      description
      permissions
      allowedIps
      users {
        id
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_GROUP = gql`
  mutation EDIT_GROUP(
    $group: ID!
    $name: String!
    $description: String
    $color: String!
    $permissions: [Permission!]!
    $allowedIps: [String!]
  ) {
    editGroup(
      group: $group
      name: $name
      color: $color
      description: $description
      permissions: $permissions
      allowedIps: $allowedIps
    ) {
      id
      name
      color
      description
      permissions
      allowedIps
      users {
        id
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_GROUP = gql`
  mutation DELETE_GROUP($group: String!, $newGroup: String) {
    deleteGroup(group: $group, newGroup: $newGroup) {
      id
    }
  }
`
export const ADD_NEW_MESSAGE = gql`
  mutation ADD_NEW_MESSAGE(
    $name: String!
    $details: String!
    $active: Boolean!
    $when: When
    $at: Int
    $day: Int
    $before: Int
    $branch: ID
    $types: [CommunicationTypes!]!
    $appointmentTypes: [AppointmentStatus]
    $appointmentType: [AppointmentType]
    $whatsAppTemplate: JSON
  ) {
    addNewMessage(
      name: $name
      details: $details
      active: $active
      when: $when
      at: $at
      day: $day
      before: $before
      branch: $branch
      types: $types
      appointmentTypes: $appointmentTypes
      appointmentType: $appointmentType
      whatsAppTemplate: $whatsAppTemplate
    ) {
      id
      name
      details
      active
      when
      at
      day
      before
      types
      whatsAppTemplate
      appointmentTypes
      appointmentType
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      branch {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_MESSAGE = gql`
  mutation EDIT_MESSAGE(
    $message: ID!
    $name: String!
    $details: String!
    $active: Boolean!
    $when: When
    $at: Int
    $day: Int
    $before: Int
    $branch: ID
    $types: [CommunicationTypes!]!
    $appointmentTypes: [AppointmentStatus]
    $appointmentType: [AppointmentType]
    $components: String
    $whatsAppTemplate: JSON
  ) {
    editMessage(
      message: $message
      name: $name
      active: $active
      details: $details
      when: $when
      at: $at
      day: $day
      before: $before
      branch: $branch
      types: $types
      appointmentTypes: $appointmentTypes
      appointmentType: $appointmentType
      components: $components
      whatsAppTemplate: $whatsAppTemplate
    ) {
      id
      name
      details
      active
      when
      at
      day
      before
      types
      whatsAppTemplate
      createdAt
      updatedAt
      appointmentTypes
      appointmentType
      template {
        id
        status
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      branch {
        id
        name
      }
    }
  }
`
export const DELETE_MESSAGE = gql`
  mutation DELETE_MESSAGE($message: ID!) {
    deleteMessage(message: $message) {
      id
    }
  }
`
export const ADD_NEW_FREE_FORM = gql`
  mutation ADD_NEW_FREE_FORM(
    $name: String!
    $content: String
    $jsonForm: String
    $signRequired: Boolean
    $showOnline: Boolean
    $expiresIn: Int
  ) {
    addNewFreeForm(
      name: $name
      content: $content
      jsonForm: $jsonForm
      signRequired: $signRequired
      showOnline: $showOnline
      expiresIn: $expiresIn
    ) {
      id
      name
      content
      jsonForm
      expiresIn
      createdAt
      updatedAt
      signRequired
      showOnline
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_FREE_FORM = gql`
  mutation EDIT_FREE_FORM(
    $form: ID!
    $name: String!
    $content: String
    $jsonForm: String
    $signRequired: Boolean
    $showOnline: Boolean
    $expiresIn: Int
  ) {
    editFreeForm(
      name: $name
      content: $content
      jsonForm: $jsonForm
      form: $form
      signRequired: $signRequired
      showOnline: $showOnline
      expiresIn: $expiresIn
    ) {
      id
      name
      content
      jsonForm
      expiresIn
      createdAt
      updatedAt
      signRequired
      showOnline
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_FREE_FORM = gql`
  mutation DELETE_FREE_FORM($form: ID!) {
    deleteFreeForm(form: $form) {
      id
    }
  }
`
export const RESEND_MESSAGE = gql`
  mutation RESEND_MESSAGE($message: ID!, $type: CommunicationTypes) {
    resendMessage(message: $message, type: $type) {
      id
      to
      status
      pending
      waPending
      emailPending
      length
    }
  }
`
export const ADD_NEW_MONTHLY_EXPENSE = gql`
  mutation ADD_NEW_MONTHLY_EXPENSE(
    $name: String
    $details: String
    $type: ExpenseType!
    $amount: Float!
    $user: ID
    $branch: ID!
    $other: String
    $automatic: Boolean
    $active: Boolean!
    $paymentType: PaymentType
  ) {
    addNewMonthlyExpense(
      name: $name
      details: $details
      type: $type
      amount: $amount
      user: $user
      branch: $branch
      other: $other
      automatic: $automatic
      active: $active
      paymentType: $paymentType
    ) {
      id
      name
      type
      details
      amount
      other
      automatic
      active
      paymentType
      branch {
        id
        name
      }
      user {
        id
        name
        group {
          id
          color
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const EDIT_MONTHLY_EXPENSE = gql`
  mutation EDIT_MONTHLY_EXPENSE(
    $monthlyExpense: ID!
    $name: String
    $details: String
    $type: ExpenseType!
    $amount: Float!
    $user: ID
    $branch: ID!
    $other: String
    $automatic: Boolean
    $active: Boolean!
    $paymentType: PaymentType
  ) {
    editMonthlyExpense(
      monthlyExpense: $monthlyExpense
      name: $name
      details: $details
      type: $type
      amount: $amount
      user: $user
      branch: $branch
      other: $other
      automatic: $automatic
      active: $active
      paymentType: $paymentType
    ) {
      id
      name
      type
      details
      amount
      other
      automatic
      active
      paymentType
      branch {
        id
        name
      }
      user {
        id
        name
        group {
          id
          color
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const DELETE_MONTHLY_EXPENSE = gql`
  mutation DELETE_MONTHLY_EXPENSE($monthlyExpense: ID!) {
    deleteMonthlyExpense(monthlyExpense: $monthlyExpense) {
      id
    }
  }
`
export const ADD_NEW_EXPENSE = gql`
  mutation ADD_NEW_EXPENSE(
    $generatedID: String
    $name: String
    $details: String
    $type: ExpenseType!
    $mainType: ExpenseMainType!
    $other: String
    $amount: Float!
    $items: Float!
    $user: ID
    $supplier: ID
    $lab: ID
    $branch: ID!
    $date: DateTime!
    $paymentType: PaymentType
    $paid: Float
    $isInstallments: Boolean
    $automatic: Boolean
    $installment: Float
    $every: Int
    $interval: String
    $confirmed: Boolean
    $isDebt: Boolean
    $orderItems: [OrderItemInput]
    $treasury: ID
    $paymentOther: String
    $inventoryOrder: ID
  ) {
    addNewExpense(
      generatedID: $generatedID
      name: $name
      details: $details
      type: $type
      mainType: $mainType
      amount: $amount
      items: $items
      user: $user
      supplier: $supplier
      lab: $lab
      branch: $branch
      date: $date
      paymentType: $paymentType
      other: $other
      paid: $paid
      isInstallments: $isInstallments
      automatic: $automatic
      installment: $installment
      every: $every
      interval: $interval
      confirmed: $confirmed
      isDebt: $isDebt
      orderItems: $orderItems
      treasury: $treasury
      paymentOther: $paymentOther
      inventoryOrder: $inventoryOrder
    ) {
      id
      name
      type
      mainType
      details
      amount
      items
      date
      other
      paid
      isInstallments
      automatic
      installment
      every
      interval
      confirmed
      isDebt
      purchaseOrderItems {
        id
        name
        total
        quantity
      }
      branch {
        id
        name
      }
      supplier {
        id
        name
      }
      lab {
        id
        name
      }
      user {
        id
        name
        group {
          id
          color
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const EDIT_EXPENSE = gql`
  mutation EDIT_EXPENSE(
    $expense: ID!
    $name: String
    $details: String
    $type: ExpenseType!
    $mainType: ExpenseMainType!
    $other: String
    $amount: Float!
    $items: Float!
    $user: ID
    $supplier: ID
    $lab: ID
    $branch: ID!
    $date: DateTime!
    $paymentType: PaymentType
    $paid: Float
    $isInstallments: Boolean
    $automatic: Boolean
    $installment: Float
    $every: Int
    $interval: String
    $confirmed: Boolean
    $isDebt: Boolean
    $orderItems: [OrderItemInput]
    $treasury: ID
    $paymentOther: String
  ) {
    editExpense(
      expense: $expense
      name: $name
      details: $details
      type: $type
      mainType: $mainType
      amount: $amount
      items: $items
      user: $user
      supplier: $supplier
      lab: $lab
      branch: $branch
      date: $date
      other: $other
      paymentType: $paymentType
      paid: $paid
      isInstallments: $isInstallments
      automatic: $automatic
      installment: $installment
      every: $every
      interval: $interval
      confirmed: $confirmed
      isDebt: $isDebt
      orderItems: $orderItems
      treasury: $treasury
      paymentOther: $paymentOther
    ) {
      id
      name
      type
      mainType
      details
      amount
      items
      date
      other
      paid
      isInstallments
      automatic
      installment
      every
      interval
      confirmed
      isDebt
      purchaseOrderItems {
        id
        name
        total
        quantity
      }
      branch {
        id
        name
      }
      supplier {
        id
        name
      }
      lab {
        id
        name
      }
      user {
        id
        name
        group {
          id
          color
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const DELETE_EXPENSE = gql`
  mutation DELETE_EXPENSE($expense: ID!) {
    deleteExpense(expense: $expense) {
      id
    }
  }
`
export const CONFIRM_EXPENSE = gql`
  mutation CONFIRM_EXPENSE($expense: ID!) {
    confirmExpense(expense: $expense) {
      id
      confirmed
    }
  }
`
export const ADD_NEW_INCOME = gql`
  mutation ADD_NEW_INCOME(
    $name: String
    $details: String
    $type: IncomeType!
    $other: String
    $amount: Float!
    $user: ID
    $branch: ID!
    $date: DateTime!
    $paymentType: PaymentType!
    $treasury: ID
    $inventoryOrder: ID
  ) {
    addNewIncome(
      name: $name
      details: $details
      type: $type
      amount: $amount
      user: $user
      branch: $branch
      date: $date
      other: $other
      paymentType: $paymentType
      treasury: $treasury
      inventoryOrder: $inventoryOrder
    ) {
      id
      name
      type
      details
      amount
      date
      other
      paymentType
      user {
        id
        name
        group {
          id
          color
        }
      }
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const EDIT_INCOME = gql`
  mutation EDIT_INCOME(
    $income: ID!
    $name: String
    $details: String
    $type: IncomeType!
    $other: String
    $amount: Float!
    $user: ID
    $branch: ID!
    $date: DateTime!
    $paymentType: PaymentType!
  ) {
    editIncome(
      income: $income
      name: $name
      details: $details
      type: $type
      amount: $amount
      user: $user
      branch: $branch
      date: $date
      other: $other
      paymentType: $paymentType
    ) {
      id
      name
      type
      details
      amount
      date
      other
      paymentType
      user {
        id
        name
        group {
          id
          color
        }
      }
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const DELETE_INCOME = gql`
  mutation DELETE_INCOME($income: ID!) {
    deleteIncome(income: $income) {
      id
    }
  }
`
export const ADD_NEW_LAB = gql`
  mutation ADD_NEW_LAB($name: String!, $number: String, $email: String, $details: String, $disabled: Boolean) {
    addNewLab(name: $name, number: $number, email: $email, details: $details, disabled: $disabled) {
      id
      name
      number
      email
      details
      createdAt
      updatedAt
      disabled
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_LAB = gql`
  mutation EDIT_LAB($lab: ID!, $name: String!, $number: String, $email: String, $details: String, $disabled: Boolean) {
    editLab(lab: $lab, name: $name, number: $number, email: $email, details: $details, disabled: $disabled) {
      id
      name
      number
      email
      details
      disabled
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_LAB = gql`
  mutation DELETE_LAB($lab: ID!) {
    deleteLab(lab: $lab) {
      id
    }
  }
`
export const ADD_NEW_LAB_ITEM = gql`
  mutation ADD_NEW_LAB($lab: ID!, $name: String!, $price: Float!, $details: String, $images: [String]) {
    addNewLabItem(lab: $lab, name: $name, price: $price, details: $details, images: $images) {
      id
      name
      price
      details
      images
      createdAt
      updatedAt
      lab {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_LAB_ITEM = gql`
  mutation EDIT_LAB($labItem: ID!, $name: String!, $price: Float!, $details: String, $images: [String]) {
    editLabItem(labItem: $labItem, name: $name, price: $price, details: $details, images: $images) {
      id
      name
      price
      details
      images
      createdAt
      updatedAt
      lab {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_LAB_ITEM = gql`
  mutation DELETE_LAB($labItem: ID!) {
    deleteLabItem(labItem: $labItem) {
      id
    }
  }
`
export const ADD_NEW_SUPPLIER = gql`
  mutation ADD_NEW_SUPPLIER($name: String!, $number: String, $email: String, $details: String, $disabled: Boolean) {
    addNewSupplier(name: $name, number: $number, email: $email, details: $details, disabled: $disabled) {
      id
      name
      number
      email
      details
      createdAt
      updatedAt
      disabled
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_SUPPLIER = gql`
  mutation EDIT_SUPPLIER($supplier: ID!, $name: String!, $number: String, $email: String, $details: String, $disabled: Boolean) {
    editSupplier(supplier: $supplier, name: $name, number: $number, email: $email, details: $details, disabled: $disabled) {
      id
      name
      number
      email
      details
      disabled
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_SUPPLIER = gql`
  mutation DELETE_SUPPLIER($supplier: ID!) {
    deleteSupplier(supplier: $supplier) {
      id
    }
  }
`
export const ADD_NEW_LAB_ORDER = gql`
  mutation ADD_NEW_LAB_ORDER(
    $lab: ID
    $labItem: ID
    $branch: ID!
    $patient: ID
    $name: String!
    $details: String
    $price: Float
    $items: Float
    $due: DateTime
    $paid: Boolean
    $received: Boolean
    $expense: Boolean
    $images: [String]
    $user: ID
    $treasury: ID
    $type: PaymentType
    $sms: Boolean
    $shade: String
    $tooth: [Int]
    $operation: ID
    $child: Boolean
    $delivered: Boolean
    $users: [ID]
    $operationStep: ID
  ) {
    addNewLabOrder(
      lab: $lab
      labItem: $labItem
      branch: $branch
      patient: $patient
      name: $name
      details: $details
      price: $price
      items: $items
      due: $due
      paid: $paid
      received: $received
      expense: $expense
      images: $images
      user: $user
      treasury: $treasury
      type: $type
      sms: $sms
      shade: $shade
      tooth: $tooth
      operation: $operation
      child: $child
      delivered: $delivered
      users: $users
      operationStep: $operationStep
    ) {
      id
      name
      price
      items
      due
      paid
      received
      details
      images
      shade
      tooth
      child
      delivered
      operation {
        procedure {
          id
          name
        }
        condition {
          id
          name
        }
      }
      lab {
        id
        name
      }
      labItem {
        id
        name
        images
        price
      }
      expense {
        id
        name
        paid
        amount
        user {
          id
          name
        }
      }
      branch {
        id
        name
      }
      user {
        id
        name
      }
      users {
        id
        name
      }
      patient {
        id
        firstName
        lastName
      }
      paidAt
      receivedAt
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_LAB_ORDER = gql`
  mutation EDIT_LAB_ORDER(
    $labOrder: ID!
    $lab: ID
    $labItem: ID
    $branch: ID!
    $patient: ID
    $name: String!
    $details: String
    $price: Float
    $items: Float
    $due: DateTime
    $paid: Boolean
    $expense: Boolean
    $images: [String]
    $shade: String
    $tooth: [Int]
    $received: Boolean
    $user: ID
    $child: Boolean
    $treasury: ID
    $type: PaymentType
    $delivered: Boolean
    $users: [ID]
  ) {
    editLabOrder(
      labOrder: $labOrder
      lab: $lab
      labItem: $labItem
      branch: $branch
      patient: $patient
      name: $name
      details: $details
      price: $price
      items: $items
      due: $due
      paid: $paid
      expense: $expense
      images: $images
      shade: $shade
      tooth: $tooth
      child: $child
      received: $received
      user: $user
      treasury: $treasury
      type: $type
      delivered: $delivered
      users: $users
    ) {
      id
      name
      price
      items
      due
      paid
      received
      details
      shade
      tooth
      child
      delivered
      operation {
        procedure {
          id
          name
        }
        condition {
          id
          name
        }
      }
      lab {
        id
        name
      }
      labItem {
        id
        name
        images
        price
      }
      expense {
        id
        name
        paid
        amount
        user {
          id
          name
        }
      }
      branch {
        id
        name
      }
      user {
        id
        name
      }
      users {
        id
        name
      }
      patient {
        id
        firstName
        lastName
      }
      paidAt
      receivedAt
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_LAB_ORDER = gql`
  mutation DELETE_LAB_ORDER($labOrder: ID!) {
    deleteLabOrder(labOrder: $labOrder) {
      id
    }
  }
`

export const DELETE_REMINDER_INSTANCE = gql`
  mutation DELETE_REMINDER_INSTANCE($reminderInstance: ID!) {
    deleteReminderInstance(reminderInstance: $reminderInstance) {
      id
    }
  }
`

export const MARK_PAYMENTS_CLAIMED = gql`
  mutation MARK_PAYMENTS_CLAIMED(
    $payment: ID
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $insuranceCompanies: [ID]
  ) {
    markPaymentsClaimed(
      payment: $payment
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      rangeDate: $rangeDate
      filters: $filters
      insuranceCompanies: $insuranceCompanies
    ) {
      id
      claimed
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`

export const MARK_LAB_ORDERS_RECEIVED = gql`
  mutation MARK_LAB_ORDERS_RECEIVED(
    $labOrder: ID
    $branchId: ID
    $userId: ID
    $lab: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $patient: ID
    $assignedToId: ID
    $operation: ID
  ) {
    markLabOrdersReceived(
      labOrder: $labOrder
      branchId: $branchId
      userId: $userId
      lab: $lab
      rangeDate: $rangeDate
      filters: $filters
      patient: $patient
      assignedToId: $assignedToId
      operation: $operation
    ) {
      id
      received
      receivedAt
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`

export const MARK_LAB_ORDERS_DELIVERED = gql`
  mutation MARK_LAB_ORDERS_DELIVERED(
    $branchId: ID
    $userId: ID
    $lab: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $patient: ID
    $assignedToId: ID
    $labOrder: ID
    $operation: ID
  ) {
    markLabOrdersDelivered(
      branchId: $branchId
      userId: $userId
      lab: $lab
      rangeDate: $rangeDate
      filters: $filters
      patient: $patient
      assignedToId: $assignedToId
      labOrder: $labOrder
      operation: $operation
    ) {
      id
      delivered
    }
  }
`

export const EDIT_FORM = gql`
  mutation EDIT_FORM(
    $branch: ID!
    $prescriptionJsonForm: String
    $invoiceJsonForm: String
    $chartJsonForm: String
    $expensesJsonForm: String
    $labOrderJsonForm: String
    $freeFormJsonForm: String
  ) {
    editForm(
      branch: $branch
      prescriptionJsonForm: $prescriptionJsonForm
      invoiceJsonForm: $invoiceJsonForm
      chartJsonForm: $chartJsonForm
      expensesJsonForm: $expensesJsonForm
      labOrderJsonForm: $labOrderJsonForm
      freeFormJsonForm: $freeFormJsonForm
    ) {
      id
      prescriptionJsonForm
      invoiceJsonForm
      chartJsonForm
      expensesJsonForm
      labOrderJsonForm
      freeFormJsonForm
    }
  }
`

export const ADD_NEW_EXPENSE_PAYMENT = gql`
  mutation ADD_NEW_EXPENSE_PAYMENT(
    $expense: ID!
    $amount: Float!
    $type: PaymentType!
    $other: String
    $details: String
    $createdAt: DateTime
    $images: [String]
    $treasury: ID
    $branch: ID!
  ) {
    addNewExpensePayment(
      expense: $expense
      amount: $amount
      type: $type
      other: $other
      details: $details
      createdAt: $createdAt
      images: $images
      treasury: $treasury
      branch: $branch
    ) {
      id
      amount
      type
      other
      details
      createdAt
      updatedAt
      images
      expense {
        id
        name
        paid
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_EXPENSE_PAYMENT = gql`
  mutation EDIT_EXPENSE_PAYMENT(
    $payment: ID!
    $type: PaymentType!
    $other: String
    $details: String
    $createdAt: DateTime
    $images: [String]
  ) {
    editExpensePayment(payment: $payment, type: $type, other: $other, details: $details, createdAt: $createdAt, images: $images) {
      id
      amount
      type
      other
      details
      images
      createdAt
      updatedAt
      expense {
        id
        name
        paid
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_EXPENSE_PAYMENT = gql`
  mutation DELETE_EXPENSE_PAYMENT($payment: ID!) {
    deleteExpensePayment(payment: $payment) {
      id
    }
  }
`
export const REFUND_EXPENSE_PAYMENT = gql`
  mutation REFUND_EXPENSE_PAYMENT($payment: ID!, $treasury: ID, $type: PaymentType, $branch: ID!) {
    refundExpensePayment(payment: $payment, treasury: $treasury, type: $type, branch: $branch) {
      id
      refunded
      refundedAt
      refundedBy {
        id
        name
      }
    }
  }
`
export const ADD_EXPENSES_BULK_PAYMENT = gql`
  mutation ADD_EXPENSES_BULK_PAYMENT(
    $branchId: ID
    $assignedToId: ID
    $userId: ID
    $supplier: ID
    $lab: ID
    $labItem: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
    $amount: Float!
    $type: PaymentType!
    $other: String
    $details: String
    $createdAt: DateTime
    $images: [String]
    $treasury: ID
    $branch: ID!
  ) {
    addExpensesBulkPayment(
      branchId: $branchId
      assignedToId: $assignedToId
      userId: $userId
      supplier: $supplier
      lab: $lab
      labItem: $labItem
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
      amount: $amount
      type: $type
      other: $other
      details: $details
      createdAt: $createdAt
      images: $images
      treasury: $treasury
      branch: $branch
    ) {
      id
      amount
      type
      other
      details
      createdAt
      updatedAt
      images
      expense {
        id
        name
        paid
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export const FILL_PATIENT_REMINDER = gql`
  mutation FILL_PATIENT_REMINDER($items: [NewPatientReminderItem!]!) {
    fillPatientReminder(items: $items)
  }
`
export const FILL_FREE_FORM = gql`
  mutation FILL_FREE_FORM($items: [NewFreeFormItem!]!) {
    fillFreeForm(items: $items)
  }
`
export const FILL_MESSAGE = gql`
  mutation FILL_MESSAGE($items: [NewMessageItem!]!) {
    fillMessage(items: $items)
  }
`

export const ADD_NEW_TREASURY = gql`
  mutation ADD_NEW_TREASURY(
    $name: String!
    $publicName: String!
    $number: String
    $email: String
    $details: String
    $type: PaymentType!
    $initialBalance: Float!
    $users: [ID!]!
    $branchId: ID
    $leftOver: Float
    $automatic: Boolean
    $transferAt: DateTime
    $transferPercent: Float
    $deductFromCredit: Float
    $to: ID
    $user: ID
  ) {
    addNewTreasury(
      name: $name
      publicName: $publicName
      number: $number
      email: $email
      details: $details
      type: $type
      initialBalance: $initialBalance
      users: $users
      branchId: $branchId
      leftOver: $leftOver
      automatic: $automatic
      transferAt: $transferAt
      transferPercent: $transferPercent
      deductFromCredit: $deductFromCredit
      to: $to
      user: $user
    ) {
      id
      name
      number
      email
      details
      publicName
      type
      initialBalance
      balance
      leftOver
      automatic
      transferAt
      transferPercent
      deductFromCredit
      transferTo {
        id
        name
      }
      users {
        id
        name
        group {
          id
          name
          color
        }
      }
      branch {
        id
        name
      }
      user {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_TREASURY = gql`
  mutation EDIT_TREASURY(
    $treasury: ID!
    $name: String!
    $publicName: String!
    $number: String
    $email: String
    $details: String
    $type: PaymentType!
    $users: [ID!]!
    $branchId: ID
    $leftOver: Float
    $automatic: Boolean
    $transferAt: DateTime
    $transferPercent: Float
    $deductFromCredit: Float
    $to: ID
    $user: ID
  ) {
    editTreasury(
      treasury: $treasury
      name: $name
      publicName: $publicName
      number: $number
      email: $email
      details: $details
      type: $type
      users: $users
      branchId: $branchId
      leftOver: $leftOver
      automatic: $automatic
      transferAt: $transferAt
      transferPercent: $transferPercent
      deductFromCredit: $deductFromCredit
      to: $to
      user: $user
    ) {
      id
      name
      number
      email
      details
      publicName
      type
      leftOver
      automatic
      transferAt
      transferPercent
      deductFromCredit
      transferTo {
        id
        name
      }
      users {
        id
        name
        group {
          id
          name
          color
        }
      }
      branch {
        id
        name
      }
      user {
        id
        name
      }
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_TREASURY = gql`
  mutation DELETE_TREASURY($treasury: ID!) {
    deleteTreasury(treasury: $treasury) {
      id
    }
  }
`
export const ADD_NEW_TREASURY_TRANSACTION = gql`
  mutation ADD_NEW_TREASURY_TRANSACTION(
    $amount: Float!
    $treasury: ID!
    $to: ID!
    $user: ID
    $transactionId: String
    $branchId: ID
    $images: [String]
    $details: String
  ) {
    addNewTreasuryTransaction(
      amount: $amount
      treasury: $treasury
      to: $to
      user: $user
      transactionId: $transactionId
      branchId: $branchId
      images: $images
      details: $details
    ) {
      id
      type
      amount
      other
      details
      images
      transactionId
      referenceId
      incoming
      pending
      confirmed
      initialBalance
      balance
      room
      receivedAt
      updatedAt
      createdAt
      treasury {
        id
        publicName
        balance
      }
      branch {
        id
        name
      }
      user {
        id
        name
      }
      receivedBy {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export const CONFIRM_TRANSACTION = gql`
  mutation CONFIRM_TRANSFER($transaction: ID!) {
    confirmTransaction(transaction: $transaction) {
      id
      confirmed
      receivedAt
      receivedBy {
        id
        name
      }
    }
  }
`

export const CONFIRM_RECEIVING_TRANSACTION = gql`
  mutation CONFIRM_RECEIVING_TRANSACTION($transaction: ID!) {
    confirmReceivingTransaction(transaction: $transaction) {
      id
      pending
      receivedAt
      receivedBy {
        id
        name
      }
    }
  }
`

export const EDIT_TRANSACTION = gql`
  mutation EDIT_TRANSFER($transaction: ID!, $details: String, $images: [String], $transactionId: String) {
    editTransaction(transaction: $transaction, details: $details, images: $images, transactionId: $transactionId) {
      id
      details
      images
      transactionId
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`

export const CANCEL_COMMUNICATIONS = gql`
  mutation CANCEL_COMMUNICATIONS(
    $id: ID
    $message: ID
    $searchTerm: String
    $rangeDate: [DateTime!]
    $filters: Filter
    $lab: ID
  ) {
    cancelCommunications(
      id: $id
      message: $message
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      filters: $filters
      lab: $lab
    ) {
      id
      pending
      emailPending
      waPending
      canceled
    }
  }
`

export const MERGE_PATIENT = gql`
  mutation MERGE_PATIENT($patient: ID!, $newPatient: ID!) {
    mergePatient(patient: $patient, newPatient: $newPatient) {
      id
    }
  }
`

export const MERGE_USER = gql`
  mutation MERGE_USER($user: ID!, $newUser: ID!) {
    mergeUser(user: $user, newUser: $newUser) {
      id
      pendingMerge
      mergeToId
    }
  }
`

export const CANCEL_USER_MERGE = gql`
  mutation CANCEL_USER_MERGE($user: ID!) {
    cancelUserMerge(user: $user) {
      id
      pendingMerge
      mergeToId
    }
  }
`

export const UPDATE_SALARY_ADJUSTMENT_TYPES = gql`
  mutation UPDATE_TAG_TYPES($types: String!) {
    updateSalaryAdjustmentsTypes(types: $types) {
      id
      salaryAdjustmentTypes
    }
  }
`

export const UPDATE_INVENTORY_TYPES = gql`
  mutation UPDATE_INVENTORY_TYPES($types: String!) {
    updateInventoryTypes(types: $types) {
      id
      inventoryTypes
    }
  }
`

export const UPDATE_EXPENSE_TYPES = gql`
  mutation UPDATE_EXPENSE_TYPES($types: String!) {
    updateExpenseTypes(types: $types) {
      id
      expenseTypes
    }
  }
`

export const UPDATE_PAYMENT_TYPES = gql`
  mutation UPDATE_PAYMENT_TYPES($types: String!) {
    updatePaymentTypes(types: $types) {
      id
      paymentTypes
    }
  }
`

export const UPDATE_INCOME_TYPES = gql`
  mutation UPDATE_INCOME_TYPES($types: String!) {
    updateIncomeTypes(types: $types) {
      id
      incomeTypes
    }
  }
`

export const UPDATE_APPOINTMENT_TYPES = gql`
  mutation UPDATE_APPOINTMENT_TYPES($types: String!) {
    updateAppointmentTypes(types: $types) {
      id
      appointmentTypes
    }
  }
`

export const EDIT_ATTENDANCE_LOCATIONS = gql`
  mutation EDIT_ATTENDANCE_LOCATIONS($attendanceLocations: [String!]!, $acceptedRange: Float!) {
    editAttendanceLocations(attendanceLocations: $attendanceLocations, acceptedRange: $acceptedRange) {
      id
      attendanceLocations
      acceptedRange
    }
  }
`

export const EDIT_BRANDING_COLOR = gql`
  mutation EDIT_BRANDING_COLOR($input: BrandingColorInput!) {
    patientApp {
      editBrandingColor(input: $input) {
        success
        data {
          id
        }
      }
    }
  }
`
